<template>
  <div class="g-head">
    <div class="g-head-content" style="justify-content: space-between">
      <div class="content-l">
        <img src="@assets/img/icmefEn.png" @click="$router.push('/homeEn')" />
      </div>
      <div class="content-c" style="display:flex;align-items: center;">
        <div class="but1" @click="goRouter(1)">
          Book a stand
        </div>
        <div class="but2" @click="goRouter(2)">
          Become a visitor
        </div>
        <!-- <div class="content-c-top">
          <span :class="searchType == 0?'active':''" @click="switchSearch(0)">Search for products</span>
          <span :class="searchType == 1?'active':''" @click="switchSearch(1)">Search for exhibitors</span>
        </div>
        <div class="content-c-bottom">
          <input @keyup.enter="search()" v-if="searchType == 0" type="text" v-model="proText" placeholder="Please enter the key words" />
          <input @keyup.enter="search()" v-if="searchType == 1" type="text" v-model="exText" placeholder="Please enter the key words" />
          <span @click="search()">Search</span>
        </div> -->
      </div>
    </div>

    <editInfo
      :show="modelShow"
      :modelTitle="modelTitle"
      @close="modelShow = false"
      @finsh="finsh"
    ></editInfo>
    <myCollect :show="collectOpen" @close="collectOpen = false"></myCollect>
    <proCollect :show="procollectOpen" @close="procollectOpen = false"></proCollect>

    <gLogin :show="show" :isPwd="isPwd" @close="show = false" @btnclick="descclick" />

    <pop1
      :popData="popData"
      :productLogo="productLogo"
      :isShowDisIndex="isShowDisIndex"
    ></pop1>
  </div>
</template>

<script>
import editInfo from "../modal/edit-info";
import myCollect from "../modal/my-collect";
import proCollect from "../modal/pro-collect";
import gLogin from "@components/En/gLogin/gLogin.vue";

import pop1 from "./dialog.vue";

import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "g-head",
  data() {
    return {
      modelShow: false,
      collectOpen: false,
      procollectOpen: false,
      modelTitle: "我的信息",
      searchType: 0, // 0 找产品，1 找展商
      proText: "",
      exText: "",

      productLogo: "",
      isShowDisIndex: "",
      popData: {},

      //   登录
      isActive: true,
      isPwd: false,
      show: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      searchContent: "exhibitor/getSearchContent",
    }),
  },
  components: {
    editInfo,
    myCollect,
    gLogin,
    pop1,
    proCollect,
  },
  watch: {
    searchContent(val, oldVal) {
      if (val == "") {
        this.proText = "";
        this.exText = "";
      }
    },
  },
  created() {
    console.log(this.user);
  },
  methods: {
    ...mapActions({
      exit: "loginModule/exit",
      getProductIsWin: "exhibitor/getProductIsWin",
    }),
    ...mapMutations({
      setSearchType: "exhibitor/setSearchType",
      setSearchContent: "exhibitor/setSearchContent",
    }),

    goRouter(index) {
      let url = "";
      if (index == 1) {
        url = "https://i.cmef.com.cn/join-loginEn?t=1748331884441";
      } else if (index == 2) {
        url =
          "https://reg.reed-sinopharm.com/pc/?_gl=11i5d399_gcl_au*MTI2NTkzNDYwMy4xNzQ4MzA5NDI5#/login?id=c534464e36a54dd494454150b90dbaff&channelUuid=7836cfe827ad449aac826c8b05d1470d";
      }
      window.open(url, "_blank");
    },
    search() {
      this.$router.push("/ex-listEn");
      if (this.searchType == 0) {
        this.isPwd = true;
        this.isActive = false;

        let accountPassword = sessionStorage.getItem("accountPassword");
        let emailLogin = sessionStorage.getItem("emailLogin");
        console.log(accountPassword);
        console.log(emailLogin);
        console.log(this.user);
        if (accountPassword || emailLogin) {
          this.descclick();
        } else {
          this.show = true;
          return;
        }
      } else {
        this.setSearchType(1);
        this.setSearchContent(this.exText);
      }
    },
    switchSearch(e) {
      // if (e == 0) {
      //   this.exText = "";
      // } else {
      //   this.proText = "";
      // }
      this.searchType = e;
    },

    closeSearch() {
      this.isShowDisIndex = false;
    },

    // 点击登录 调用的方法
    async descclick(item, item1, item2) {
      console.log(item, "itemitemitem");
      this.setSearchType(0);
      this.setSearchContent(this.proText);
      // this.FromIdId = item.id
      // this.company = item.name
      // this.category = item.businessType
      // this.contactInfoList = item1

      // this.proList = item2.items
      //在此处去查询是否中奖，并且打开弹窗

      if (!this.user) {
        this.show = true;
        return;
      }

      let opt = {
        userId: this.user.userId,
        keyName: this.proText,
        type: "pcEn",
        exids: [
          "39BF1607-2210-4652-8573-6C1CF6EA352B",
          "7057DA04-1D2A-437D-B791-80448F9A33DB",
          "1A827850-58EF-44D3-BD69-FAFE995A30AB",
          "678F8C16-9474-4762-B012-9D5DAD231E5D",
          "FC66257A-AEA5-4D4B-B6B9-AD06A5259E1B",
          "A20542D0-3F06-4163-BC4B-26F6CAC7D4B3",
          "AF920968-535D-4B73-AA41-F1D092077E34",
          "F7DC8FE5-C2CE-41BA-93DF-80B1C632DAC4",
          "601156FF-ABF5-439F-83DF-8E5F9EF180F2",
          "D2F77A00-C615-4CB6-85B4-3058F515C0AB",
          "9CBFCAEF-100F-4753-95FD-1304957883A0",
          "E9DEFAFB-5D6B-42D2-B523-C2ABAD413C75",
          "5C096D71-C5B8-4432-A0DC-7F3175B25596",
          "667ED22F-B921-4910-87B1-6ED9575CE6B1",
          "D9CA2D5A-42E0-47CB-A88B-BFE3ABDCAEF5",
          "723CAFD7-8361-4E7A-9249-E4C3C09C825B",
        ],
      };
      let data = await this.getProductIsWin(opt);
      if (data) {
        this.popData = data;
        if (data.isStart) {
          let list = JSON.parse(this.popData.productBanner);
          this.productLogo = list[0];
          this.isShowDisIndex = true;
          console.log("**********************抽奖后的拿到的数据****************", data);
        }
      }
    },

    // let emailLogin = sessionStorage.getItem('emailLogin')
    //         if (!emailLogin) {
    //             this.$Message.warning("Please log in to post");
    //             this.show = true;
    //             return;
    //         }

    finsh() {},
  },
};
</script>

<style lang="scss" scoped>
.g-head {
  width: 100%;
  height: 108px;
  background: #fff;
  padding-top: 8px;
  &-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    .content-l {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 200px;
        height: auto;
        cursor: pointer;
        margin-top: 30px;
        margin-left: -45px;
      }
    }
    .content-c {
      padding-top: 32px;
      margin-left: 265px;
      &-top {
        width: 100%;
        span {
          display: inline-block;
          width: 150px;
          height: 28px;
          color: #4d4d4d;
          font-size: 14px;
          text-align: center;
          line-height: 28px;
          cursor: pointer;
        }
        .active {
          background-color: #024c8b;
          color: #fff;
        }
      }
      &-bottom {
        display: flex;
        input {
          width: 264px;
          height: 32px;
          border: solid 1px #024c8b;
          outline: none;
          padding: 0 50px 0 10px;
          background-color: #fff;
        }
        ::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #ccc;
          font-size: 12px;
        }
        ::-moz-placeholder {
          /* Firefox 19+ */
          color: #ccc;
          font-size: 12px;
        }
        :-ms-input-placeholder {
          /* IE 10+ */
          color: #ccc;
          font-size: 12px;
        }
        :-moz-placeholder {
          /* Firefox 18- */
          color: #ccc;
          font-size: 12px;
        }
        span {
          display: inline-block;
          width: 64px;
          height: 32px;
          background-color: #024c8b;
          font-size: 14px;
          color: #fff;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .content-r {
      height: 100%;
      padding-top: 60px;
      margin-left: 400px;
      p {
        width: 124px;
        height: 32px;
        background-color: #024c8b;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
      p:first-child {
        margin-bottom: 4px;
      }
    }
  }
}
.user {
  text-align: right;
  &-logo {
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #efefee;
    }
  }
}

.but1 {
  //     display: inline-block;
  // cursor: pointer;
  // width: 120px;
  // height: 37px;
  // line-height: 35px;
  // text-align: center;
  // padding: 0px 5px;
  // background-color: rgb(27, 28, 128);
  // color: rgb(255, 255, 255);
  // text-decoration: none;
  // border: 1px solid rgb(27, 28, 128);
  // border-radius: 5px;
  // font-weight: normal;
  // transition: 0.3s;
  width: 160px;
  cursor: pointer;
  border-radius: 35px;
  padding: 10px;
  border-color: #e60012;
  background-color: #e60012;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.but2 {
  // display: inline-block;
  // cursor: pointer;
  // margin-left: 20px;
  // width: 150px;
  // height: 37px;
  // line-height: 35px;
  // text-align: center;
  // padding: 0px 5px;
  // background-color: rgb(255, 255, 255);
  // color: rgb(27, 28, 128);
  // text-decoration: none;
  // border: 1px solid rgb(27, 28, 128);
  // border-radius: 5px;
  // font-weight: normal;
  // transition: 0.3s;
  width: 160px;
  cursor: pointer;
  border-style: solid;
  border-width: 1px;
  border-color: #666;
  border-radius: 35px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
}
</style>
